import React, { useEffect, useState } from "react";
import Web3 from "web3";
import { useAppKitAccount } from "@reown/appkit/react";
import { useConnectorClient } from "wagmi";

import { ReserveContract } from "../config/contractConfig";
import ReserveContarctABI from "../abis/ReserveContarctABI.json";

import NFTABI from "../abis/NFTABI.json";

import { FaCopy, FaCheck } from "react-icons/fa";

const ITEMS_PER_PAGE = 12;

const AllTradeUsers = () => {
  const { isConnected } = useAppKitAccount();
  const { data: client } = useConnectorClient();

  const [web3, setWeb3] = useState(null);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [copiedIndex, setCopiedIndex] = useState(null);
  const [tradeFeeCollect, setTradeFeeCollect] = useState(0);
  // 🔥 NEW STATE
  const [currentIndex, setCurrentIndex] = useState(0);
const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";
  // 🔥 INIT WEB3
  useEffect(() => {
    let provider = null;

    if (client?.transport) provider = client.transport;
    else if (window.ethereum) provider = window.ethereum;

    if (provider) {
      setWeb3(new Web3(provider));
    }
  }, [client]);

  // 🔥 FETCH USERS + CURRENT INDEX
  // const fetchUsers = async () => {
  //   if (!web3) return;

  //   setLoading(true);

  //   try {
  //     const contract = new web3.eth.Contract(
  //       ReserveContarctABI,
  //       ReserveContract
  //     );

  //     // 🔥 FETCH CURRENT INDEX
  //     const currIndex = await contract.methods.currentIndex().call();
  //     setCurrentIndex(Number(currIndex));

  //       // 🔥 FETCH TOTAL TRADE FEE
  //     const fee = await contract.methods.TradeFeeCollect().call();
  //     const formattedFee = web3.utils.fromWei(fee, "ether");
  //     setTradeFeeCollect(formattedFee);

  //           const list = [];
  //     let index = 0;
  //     const MAX_LIMIT = 200;

  //     while (index < MAX_LIMIT) {
  //       try {
  //         // ✅ NEW: feeQueue fetch
  //         const data = await contract.methods.feeQueue(index).call();

  //         const user = data.user;
  //         const amount = data.amount;

  //         if (
  //           !user ||
  //           user === "0x0000000000000000000000000000000000000000"
  //         ) {
  //           break;
  //         }

  //         list.push({
  //           user,
  //           amount: web3.utils.fromWei(amount, "ether"),
  //         });

  //         index++;
  //       } catch {
  //         break;
  //       }
  //     }

  //     setUsers(list);
  //   } catch (err) {
  //     console.error(err);
  //   }

  //   setLoading(false);
  // };

// const fetchUsers = async (page = 1) => {
//   if (!web3) return;

//   setLoading(true);

//   try {
//     const contract = new web3.eth.Contract(
//       ReserveContarctABI,
//       ReserveContract
//     );

//     const currIndex = await contract.methods.currentIndex().call();
//     const current = Number(currIndex);
//     setCurrentIndex(current);

//     const fee = await contract.methods.TradeFeeCollect().call();
//     setTradeFeeCollect(web3.utils.fromWei(fee, "ether"));

//     const list = [];

//     let start;

//     // 🔥 PAGE 1 → include current
//     if (page === 1) {
//       start = current; // 👈 include current
//     } else {
//       start = current + 1 + (page - 2) * ITEMS_PER_PAGE;
//     }

//     const end = start + ITEMS_PER_PAGE - 1;

//     for (let i = start; i <= end; i++) {
//       try {
//         const data = await contract.methods.feeQueue(i).call();

//         const user = data.user;
//         const amount = data.amount;

//         if (
//           !user ||
//           user === "0x0000000000000000000000000000000000000000"
//         ) {
//           break;
//         }

//         list.push({
//           user,
//           amount: web3.utils.fromWei(amount, "ether"),
//           index: i,
//         });
//       } catch {
//         break;
//       }
//     }

//     setUsers(list);
//     setCurrentPage(page);

//   } catch (err) {
//     console.error(err);
//   }

//   setLoading(false);
// };

const fetchUsers = async (page = 1) => {
  if (!web3) return;

  setLoading(true);

  try {
    const contract = new web3.eth.Contract(
      ReserveContarctABI,
      ReserveContract
    );

    const currIndex = await contract.methods.currentIndex().call();
    const current = Number(currIndex);
    setCurrentIndex(current);

    const fee = await contract.methods.TradeFeeCollect().call();
    setTradeFeeCollect(web3.utils.fromWei(fee, "ether"));

    const list = [];

    let start, end;

    if (page === 1) {
      // 🔥 PAGE 1 SPECIAL LOGIC

      const receivedStart = Math.max(0, current - 5);
      const receivedEnd = current - 1;

      // 1️⃣ received users (max 5)
      for (let i = receivedStart; i <= receivedEnd; i++) {
        try {
          const data = await contract.methods.feeQueue(i).call();
          if (!data.user || data.user === ZERO_ADDRESS) continue;

          list.push({
            user: data.user,
            amount: web3.utils.fromWei(data.amount, "ether"),
            index: i,
          });
        } catch {}
      }

      // 2️⃣ current user
      try {
        const data = await contract.methods.feeQueue(current).call();

        if (data.user && data.user !== ZERO_ADDRESS) {
          list.push({
            user: data.user,
            amount: web3.utils.fromWei(data.amount, "ether"),
            index: current,
          });
        }
      } catch {}

      // 3️⃣ pending users fill
      let nextIndex = current + 1;

      while (list.length < ITEMS_PER_PAGE) {
        try {
          const data = await contract.methods.feeQueue(nextIndex).call();

          if (
            !data.user ||
            data.user === "0x0000000000000000000000000000000000000000"
          ) break;

          list.push({
            user: data.user,
            amount: web3.utils.fromWei(data.amount, "ether"),
            index: nextIndex,
          });

          nextIndex++;
        } catch {
          break;
        }
      }

    } else {
      // 🔥 NORMAL PAGINATION

      const start = current + 1 + (page - 2) * ITEMS_PER_PAGE;
      const end = start + ITEMS_PER_PAGE - 1;

      for (let i = start; i <= end; i++) {
        try {
          const data = await contract.methods.feeQueue(i).call();

          if (
            !data.user ||
            data.user === "0x0000000000000000000000000000000000000000"
          ) break;

          list.push({
            user: data.user,
            amount: web3.utils.fromWei(data.amount, "ether"),
            index: i,
          });
        } catch {
          break;
        }
      }
    }

    setUsers(list);
    setCurrentPage(page);

  } catch (err) {
    console.error(err);
  }

  setLoading(false);
};


  useEffect(() => {
    if (isConnected && web3) {
      fetchUsers(1);
    }
  }, [isConnected, web3]);

  const handleCopy = (addr, index) => {
    navigator.clipboard.writeText(addr);
    setCopiedIndex(index);

    setTimeout(() => setCopiedIndex(null), 1500);
  };

  // 🔥 PAGINATION
  const totalPages = Math.ceil(users.length / ITEMS_PER_PAGE);

  const currentUsers = users.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  if (loading) return <p>Loading...</p>;

  return (
    <div style={{ padding: "20px" }}>
 {/* 🔥 TOTAL FEE BOX */}
      <div
        style={{
          background: "#111",
          padding: "15px",
          borderRadius: "10px",
          marginBottom: "15px",
          border: "1px solid #ffc107",
        }}
      >
        <div style={{ fontSize: "13px", color: "#aaa" }}>
          Total Trade Fee Collected
        </div>
        <div style={{ fontSize: "22px", color: "#ffc107", fontWeight: "bold" }}>
          {tradeFeeCollect} USDT
        </div>
      </div>

      <h3>All Trade Users ({users.length})</h3>

      {users.length === 0 ? (
        <p>No users found</p>
      ) : (
        <>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
            {users.map((item, index) => {
              const short = `${item.user.slice(0, 6)}...${item.user.slice(-4)}`;
              // 🔥 STATUS LOGIC
              let status = "";
              let color = "#999";

              if (item.index < currentIndex) {
                status = "✅ Received";
                color = "#16c784";
              } else if (item.index === currentIndex) {
                status = "🟡 Current";
                color = "#ffc107";
              } else {
                status = "⏳ Pending";
                color = "#999";
              }

              return (
                <div
                  key={index}
                  style={{
                    width: "30%",
                    minWidth: "250px",
                    padding: "12px",
                    border:
                      item.index === currentIndex
                        ? "2px solid #ffc107"
                        : "1px solid #ddd",
                    borderRadius: "10px",
                    background: "#111",
                    color: "#fff",
                  }}
                >
                  <div style={{ fontSize: "12px", marginBottom: "5px" }}>
                    Address
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span>{short}</span>

                    <button
                      onClick={() => handleCopy(item.user, index)}
                      style={{
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                        color: "#ffc107",
                      }}
                    >
                      {copiedIndex === index ? (
                        <FaCheck />
                      ) : (
                        <FaCopy />
                      )}
                    </button>
                  </div>

                  
                  {/* 🔥 AMOUNT */}
                  <div style={{ fontSize: "13px", marginTop: "6px" }}>
                    Amount: {item.amount} USDT
                  </div>

                  {/* 🔥 STATUS SHOW */}
                  <div
                    style={{
                      fontSize: "12px",
                      marginTop: "6px",
                      fontWeight: "600",
                      color: color,
                    }}
                  >
                    {status}
                  </div>
                </div>
              );
            })}
          </div>

          {/* 🔥 PAGINATION */}
          {/* <div style={{ marginTop: "20px", textAlign: "center" }}>
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
              style={{ marginRight: "10px" }}
            >
              Prev
            </button>

            <span>
              Page {currentPage} / {totalPages}
            </span>

            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => p + 1)}
              style={{ marginLeft: "10px" }}
            >
              Next
            </button>
          </div> */}
        </>
      )}
    </div>
  );
};

export default AllTradeUsers;